<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-card class="no-shadow mb-2 transparent">
      <v-layout row>
        <v-flex lg12 class="pa-0">
        <v-expansion-panel class="card-r shadow-1">
          <v-expansion-panel-content class="card-r pr-4">
            <template v-slot:actions class="card-r">
              <v-icon color="primary" class="f-25">$vuetify.icons.expand</v-icon>
            </template>

            <!-- <template v-slot:header>
              <v-layout row wrap class="align-center">

              <v-flex lg5 xs12 class="right pa-0 expane  hide-pro pro pl-4">
              <div class="f-15 text-primary font-weight-bold">Student can cancel class before ( Classes )</div>
              </v-flex>
              <v-flex lg4 xs12 class="right pb-0 text-xs-right expane  hide-pro pro">
                <v-select solo class="no-shadow" background-color="transparent"
                          :items="time"
                          attach
                          chips
                          label="Class type 1"
                          placeholder="Select A Cancel Time"
                ></v-select>
              </v-flex>
              <v-flex lg2 xs12 class="right pa-0 expane  hide-pro pro">
                <v-card class="no-shadow">
                  <v-list subheader class="pa-0">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title class="f-15 text-xs-right text-capitalize grey--text" v-if="switch3">Enable</v-list-tile-title>
                        <v-list-tile-title class="f-15 text-xs-right text-capitalize grey--text" v-else>Disable</v-list-tile-title>                        </v-list-tile-content>

                      <v-list-tile-action>
                        <v-switch color="primary darken-2"
                                  v-model="switch3"></v-switch>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
              </v-layout>
            </template> -->

            <v-card class="pa-3 card-r grey lighten-4">
              <v-layout row wrap>
                <v-flex xs12 lg3 class="pro hide-pro">
                  <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">Class Type 1</div>
                  <v-select solo
                            :items="time"
                            attach
                            chips
                            label="Class Name 1"
                            placeholder="Select A Cancel Time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 lg3 class="pro hide-pro">
                  <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">Class Type 2</div>
                  <v-select solo
                            :items="time"
                            attach
                            chips
                            label="Class Name 2"
                            placeholder="Select A Cancel Time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 lg3 class="pro hide-pro">
                  <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">Class Type 3</div>
                  <v-select solo
                            :items="time"
                            attach
                            chips
                            label="Class Name 3"
                            placeholder="Select A Cancel Time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 lg3 class="pro hide-pro">
                  <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">Class Type 4</div>
                  <v-select solo
                            :items="time"
                            attach
                            chips
                            label="Class Name 3"
                            placeholder="Select A Cancel Time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 lg3 class="pro hide-pro">
                  <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">Class Type 5</div>
                  <v-select solo
                            :items="time"
                            attach
                            chips
                            label="Class Name 3"
                            placeholder="Select A Cancel Time"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card class="no-shadow mb-2 transparent">
      <v-layout row>
        <v-flex lg12 class="">
          <v-expansion-panel class="card-r shadow-1">
            <v-expansion-panel-content class="card-r pr-4">
              <template v-slot:actions class="card-r">
                <v-icon color="primary" class="f-25">$vuetify.icons.expand</v-icon>
              </template>
              <template v-slot:header>
                <v-layout row wrap class="align-center">

                  <v-flex lg11 xs12 class="right pa-0 expane  hide-pro pro">
                    <div class="f-15 text-primary font-weight-bold">Practice Exam for Students ( packages )</div>
                  </v-flex>
                  <v-flex lg1 xs12 class="right pa-0 expane  hide-pro pro">
                    <v-card class="no-shadow">
                      <v-list subheader class="pa-0">
                        <v-list-tile>
                          <!-- <v-list-tile-content>
                            <v-list-tile-title class="f-15 text-xs-right text-capitalize grey--text" v-if="switch2">Enable</v-list-tile-title>
                            <v-list-tile-title class="f-15 text-xs-right text-capitalize grey--text" v-else>Disable</v-list-tile-title>                        </v-list-tile-content>
                          <v-list-tile-action> -->
                            <!-- <v-switch color="primary darken-2" -->
                                      <!-- v-model="switch2"></v-switch> -->
                          <!--</v-list-tile-action>-->
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
              <v-card class="px-3 pb-3 card-r 4">
                <v-layout row wrap class="grey lighten-4 pa-2">
                  <v-flex xs12 lg3 class="pro hide-pro" v-for="(i,index) in packs">
                    <div class="f-12 text-xs-left w-100 mb-1 textColor font-weight-bold">{{i.test_package_data.name}}</div>
                    <v-card class="shadow-1 card-r">
                      <v-list subheader class="pa-0">
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="f-15 text-capitalize grey--text" v-if="switch1">Enable</v-list-tile-title>
                            <v-list-tile-title class="f-15 text-capitalize grey--text" v-else>Disable</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch color="primary darken-2" @change="changeStatus(packStatus[index],index,i)" v-model="packStatus[index]"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
  /* eslint-disable */
  import api from '@/utils/backend-api'

  export default {
    data: () => ({
      switch1: false,
      switch2: false,
      switch3: false,
      time: ['1day', '2day', '3day', '4day', '5day', '6day'],
      packs: [
        {
          name: 'Package Name 1'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        },
        {
          name: 'Package Name 2'
        }
      ],
      packStatus:[]
    }),
    created:function(){
      this.loadExamPackages()
    },
    methods:{
      loadExamPackages(){
        api.postData('admin/viewBookedTestPackages')
        .then(res=>{
          if(res.status==200){
            this.packs=res.data
            this.packStatus=[]
            let status=''
            for(let x=0;x<res.data.length;x++){

              if(res.data[x].status=='active'){
                status=true
              }else{
                status=false
              }
              this.packStatus.push(status)

            }
          }
        }).catch(err=>{

        })
      },
      changeStatus(oldStatus,index,data){
        let newStatus
        if(oldStatus==true){
          newStatus="active"
        }else{
          newStatus="pending"
        }
        console.log(newStatus)

        let formData={
          test_package_id:data.test_package_id,
          admin_test_package_price:(data.test_package_price).substring(0,data.test_package_price.length-3),
          status:newStatus
        }

        api.postData('admin/updateBookedTestPackage',formData)
        .then(res=>{

        })

        // console.log(this.packStatus[index])

      }
    }
  }
</script>
<style>
  .theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{
    font-size: 25px!important;
  }
  .expane .v-input__slot{
    display: block!important;
    margin-bottom: 0px!important;
  }
  .expane .v-input{
    text-align: right;
    -webkit-box-align: end;
    -ms-flex-align: end;
    display: block;
  }
  .expane .v-messages{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/SettingsLists.vue